import HttpService from "~/Scripts/services/httpService";

const instance = new HttpService( "umbraco/api/TeamApi/" );

/* eslint-disable arrow-body-style */
/* eslint-disable object-shorthand */
/* eslint-disable quote-props */

/*
 * GET
 */

/**
 * Retrieves a list of instances
 */
export const listInstances = () => {
  return instance.get( "ListInstances" );
};

/**
 * Retrieves a list of instances related to the user
 */
export const listUserInstances = () => {
  return instance.get( "listUserInstances" );
};

/*
 * Loads a specific instance
 */
export const loadInstance = id => {
  return instance.get( `LoadInstance?id=${id}` );
};

/*
 * Loads the answers for a team member or instance
 */
export const loadAnswers = ( instanceId, teamMemberId ) => {
  return instance.get( `LoadAnswers?instanceId=${instanceId}&teamMemberId=${teamMemberId}` );
};

/*
 * List members for an instance
 */
export const listMembers = instanceId => {
  return instance.get( `ListMembers?instanceId=${instanceId}` );
};

/*
 * Retrieves an team instances questions and answers
 */
export const listQuestions = () => {
  return instance.get( "ListQuestions" );
};

/*
 * Retrieves final report for an instance
 */
export const getFinalReportData = instanceId => {
  return instance.get( `GetFinalReportData?instanceId=${instanceId}` );
};

/*
 * POST
 */

/*
 * Saves answers for an instance
 */
export const saveAnswers = ( {
  instanceId,
  statementRank,
  memberId = null,
  areasOfStrength,
  areasOfWeakness,
} ) => {
  return instance.post( "SaveAnswers", {
    instanceId,
    statementRank,
    memberId,
    areasOfStrength,
    areasOfWeakness,
  } );
};

/*
 * Saves a new or existing LM 360 instance to the user's account
 */
export const saveInstance = ( {
  instanceId, instanceName, dateSubmitted, pathwayItemId,
} ) => {
  const payload = {
    instanceId,
    instanceName,
    dateSubmitted,
    pathwayItemId,
  };

  return instance.post( "SaveInstance", payload );
};

/*
 * Saves members against an team instance
 */
export const saveMembers = ( { instanceId, members } ) => {
  const payload = {
    instanceId,
    members,
  };

  return instance.post( "SaveMembers", payload );
};

/*
 * Marks a review as complete
 */
export const setReviewAsComplete = ( { memberId } ) => {
  const payload = {
    memberId,
  };

  console.log( payload );

  return instance.post( "SetReviewAsComplete", payload );
};

/*
 * Marks a member email as sent and distributes an email to the member via the database
 */
export const setMemberEmailAsSent = ( { memberId } ) => {
  return instance.post( "SetMemberEmailAsSent", JSON.stringify( memberId ) );
};

/*
 * Updates the instance's submitted date to time of execution
 */
export const setInstanceAsSubmitted = ( { instanceId } ) => {
  return instance.post( "SetInstanceAsSubmitted", JSON.stringify( instanceId ) );
};

/*
 * Marks the instance as complete resulting in it's expiration
 */
export const setInstanceAsCompleted = ( { instanceId } ) => {
  return instance.post( "SetInstanceAsCompleted", instanceId );
};

/*
 * Marks the instance as inactive
 */
export const setInstanceAsInactive = ( { instanceId } ) => {
  return instance.post( "SetInstanceAsInactive", instanceId );
};

/*
 * Marks the instance as active
 */
export const setInstanceAsActive = ( { instanceId } ) => {
  return instance.post( "SetInstanceAsActive", JSON.stringify( instanceId ) );
};
